import { Skeleton } from 'antd';

function DataViewLoader() {
  return (
    <div className="p-4 space-y-3">
        <Skeleton active />
        <Skeleton active />
        <Skeleton active />
    </div>
  )
}

export default DataViewLoader;